export const DEFAULT_PARAMS = {
    PAGE: 1,
    SIZE: 10,
    SIZE_ALL: -1,
    KEYWORD: '',
};
export const PARAMS = {
    PAGE: 'page',
    SIZE: 'size',
    KEYWORD: 'keyword',
    SORT_TYPE: 'sortType',
    SORT_BY: 'sortBy',
    TAB: 'tab',
    USER_ID: 'userId',
    CORPORATE: 'corporate',
    NICKNAME: 'nickname',
    FAMILY_NAME: 'familyName',
    STATUS: 'status',
};
